import { Index } from '@oyo_tech/oyochat_user';
import getDeviceId from '../../utils/getDeviceId';
import React from 'react';

const OyoChatWithDeviceId = props => <Index
  deviceId={getDeviceId()}
  positions={{ bottom: '77px', right: '16px' }}
  oyoChatType="oyochat"
  startChatWithExternalIntent={props.startChatWithExternalIntent}
  hideFloatingRedButton={props.hideFloatingRedButton}
/>;

export default OyoChatWithDeviceId;
